var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgO(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.017,
    height: 23.692,
    viewBox: "0 0 28.017 23.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "o",
    transform: "translate(-2.25 -3.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(2.25 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M16.616,14.8a6.419,6.419,0,0,0,2.73.661h0a6.129,6.129,0,0,0,5.517-3.491,1.063,1.063,0,0,0-.115-1.106,1.111,1.111,0,0,0-1.034-.417A3.538,3.538,0,0,1,20.28,9.151a3.648,3.648,0,0,1-.043-4.21,1.059,1.059,0,0,0,.057-1.106,1.073,1.073,0,0,0-.948-.575,6.094,6.094,0,0,0-5.115,9.425,6.218,6.218,0,0,0,2.385,2.126Z",
    transform: "translate(2.55 -3.26)",
    fill: "#2772af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M25.784,15.426s-.043-.129-.057-.187a8.168,8.168,0,0,1-1.566.172h0A8.259,8.259,0,0,1,15.985,8.3,8.961,8.961,0,0,0,8.6,14.061a5.331,5.331,0,0,0-.963-.086,5.388,5.388,0,0,0,0,10.776H25.6a4.679,4.679,0,0,0,4.669-4.669,4.629,4.629,0,0,0-4.483-4.655Z",
    transform: "translate(-2.25 -1.059)",
    fill: "#2772af"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/o.5eb1999aac927b13a8cece6cba4a78c4.svg";
export { ForwardRef as ReactComponent };